// extracted by mini-css-extract-plugin
export var avatarButton = "choose-profile-template-module--avatar-button--e9131";
export var avatarName = "choose-profile-template-module--avatar-name--559ff";
export var chooseProfile = "choose-profile-template-module--choose-profile--8681a";
export var header = "choose-profile-template-module--header--400c3";
export var headerActions = "choose-profile-template-module--header-actions--8e566";
export var itemMoveIn = "choose-profile-template-module--item-move-in--f28ee";
export var profileItem = "choose-profile-template-module--profile-item--fa81a";
export var profileList = "choose-profile-template-module--profile-list--88d39";
export var profilePickerWrapper = "choose-profile-template-module--profile-picker-wrapper--8876e";